import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBar, Box, IconButton, Toolbar, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Logo } from 'components';
import { AdminLayoutProps } from './AdminLayout.props';

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" color="primary" elevation={1}>
        <Toolbar>
          <Tooltip title="Back to app">
            <IconButton edge="start" onClick={() => navigate(-1)} sx={{ mr: 2 }}>
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
          <Logo />
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flex: 1, p: 4 }}>
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;
